import * as axios from 'axios';
import {
    DESTROY_ACCOUNT, GET_BRAND, GET_DESTROY_STATUS, GET_DEVICES, GET_ACCOUNT_PII, DELETE_SHARE, SET_COMMAND,
    GET_ACCOUNT_PII_STATUS, GET_ENV, GET_ANY_MAIL_ACCOUNT_PII, GET_ANY_MAIL_ACCOUNT_PII_STATUS, DESTROY_ANY_MAIL_ACCOUNT
} from "../types";

const middlewareFactory = callbackType => store => next => action => {
    if(apiObject[action.type]){
        const {[callbackType]: callback, isPromise} = apiObject[action.type];
        if(isPromise){
            return callback(action.payload)
                .then(payload => {
                    action.onSuccess && action.onSuccess();
                    next({...action, payload})
                })
                .catch(payload => {
                    action.onFailure && action.onFailure();
                    next({...action, payload, error: true})
                })
        }
        return next({...action, payload: callback(action.payload)})
    }
    return next(action);
};

export const axiosMiddleware = middlewareFactory('axiosCallback');

export const windowMiddleware = middlewareFactory('windowCallback');

const apiGenerator = (isPromise, axiosCallback, windowCallback) => ({isPromise, axiosCallback, windowCallback});

window.selfPortal = {
    getBrand: ()=>{},
    getDevices: ()=>{},
    destroyAccount: ()=>{},
    destroyAnyMailAccount: ()=>{},
    getDestroyStatus: ()=>{},
    deleteShare: ()=>{},
    getAccountPII: ()=>{},
    getAnyMailAccountPII: ()=>{},
    getAccountPIIStatus: ()=>{},
    removeAccountFromDevice: ()=>{},
    getEnv: ()=>{},
};

const apiObject = {
    [GET_BRAND]: apiGenerator(true, () => axios.get('/api/brand'), window.selfPortal.getBrand),
    [GET_DEVICES]: apiGenerator(true, email => axios.get('/api/devices/' + email), window.selfPortal.getDevices),
    [DESTROY_ACCOUNT]: apiGenerator(true, email => axios.post('/api/account/destroy/' + email), window.selfPortal.destroyAccount),
    [DESTROY_ANY_MAIL_ACCOUNT]: apiGenerator(true, email => axios.post('/api/account/destroy/anyMail/' + email), window.selfPortal.destroyAnyMailAccount),
    [GET_DESTROY_STATUS]: apiGenerator(true, email => axios.get('/api/account/destroy/status/' + email), window.selfPortal.getDestroyStatus),
    [DELETE_SHARE]: apiGenerator(true, share_url => axios.delete('/api/account/delete/share', { data: { share_url }}), window.selfPortal.deleteShare),
    [GET_ACCOUNT_PII]: apiGenerator(true, email => axios.get('/api/account-pii/' + email), window.selfPortal.getAccountPII),
    [GET_ANY_MAIL_ACCOUNT_PII]: apiGenerator(true, email => axios.get('/api/account-pii/anyMail/' + email), window.selfPortal.getAnyMailAccountPII),
    [GET_ACCOUNT_PII_STATUS]: apiGenerator(true, email => axios.get('/api/account-pii/status/' + email), window.selfPortal.getAccountPIIStatus),
    [GET_ANY_MAIL_ACCOUNT_PII_STATUS]: apiGenerator(true, email => axios.get('/api/account-pii/status/anyMail/' + email), window.selfPortal.getAnyMailAccountPIIStatus),
    [SET_COMMAND]: apiGenerator(true, action => axios.post('/api/devices-command?brand=' + brand, action), window.selfPortal.removeAccountFromDevice),
    [GET_ENV]: apiGenerator(true, () => axios.get('/api/env'), window.selfPortal.getEnv),
};




// WEBPACK FOOTER //
// ./src/redux/middlewares/api.js